import { api } from './client';
import { AppRole } from '@/types/role';

export const roleApi = {
  getUserRoles: async (organisationId: string): Promise<AppRole[]> => {
    const { data } = await api.get(`/api/v1/roles/app`, { params: { organization_id: organisationId } });
    return data;
  },

  getAllAvailableRoles: async (organisationId: string): Promise<AppRole[]> => {
    const { data } = await api.get(`/api/v1/organizations/${organisationId}/roles`);
    return data;
  },
}
